"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  EMAIL_TEMPLATE_IDS: () => EMAIL_TEMPLATE_IDS,
  HTTP_ERROR_CODES: () => HTTP_ERROR_CODES,
  REGEX_FORMAT_CUIT_CUIL: () => REGEX_FORMAT_CUIT_CUIL,
  REGEX_LENGTH_CUIT_CUIL: () => REGEX_LENGTH_CUIT_CUIL,
  WEB_SOCKET_EVENTS: () => WEB_SOCKET_EVENTS,
  calculateAge: () => calculateAge,
  dateToUnixTimestamp: () => dateToUnixTimestamp,
  filterEmptyArrayOfDocumentField: () => filterEmptyArrayOfDocumentField,
  formatDate: () => formatDate,
  formatDateToShortFormat: () => formatDateToShortFormat,
  getUnixTimestamp: () => getUnixTimestamp,
  getUnixTimestampInMilliseconds: () => getUnixTimestampInMilliseconds,
  isEmptyDocumentField: () => isEmptyDocumentField,
  sanitizeFilename: () => sanitizeFilename,
  unixTimestampToDate: () => unixTimestampToDate,
  validateEmail: () => validateEmail
});
module.exports = __toCommonJS(src_exports);

// src/email-template-ids/index.ts
var EMAIL_TEMPLATE_IDS = {
  SIGN_UP_DOCUMENT: "sign-up-document",
  SIGN_UP_REJECTED: "sign-up-rejected",
  SIGN_UP_APPROVED: "sign-up-approved",
  SIGN_UP_DOCUMENT_FORWARD: "sign-up-document-forward",
  CREATED_USER_AND_PASSWORD: "created-user-and-password",
  ACCESS_REQUESTS_APPROVED: "access-requests-approved",
  DIGITAL_DOSSIER_CHANGES_REQUESTED: "digital-dossier-changes-requested",
  SIGN_UP_REQUEST_CHANGES: "sign-up-request-changes",
  RELEASE_CROP_PLEDGE: "release-crop-pledge",
  CROP_PLEDGE_ACCEPTED_BY_CREDITOR: "crop-pledge-accepted-by-creditor",
  CROP_PLEDGE_REJECTED_BY_CREDITOR: "crop-pledge-rejected-by-creditor",
  CROP_PLEDGE_REQUESTED_TO_CREDITOR: "crop-pledge-requested-to-creditor",
  BACKOFFICE_CROP_PLEDGE_ACCEPTED_BY_CREDITOR: "backoffice-crop-pledge-accepted-by-creditor",
  CROP_PLEDGE_REGISTERED: "crop-pledge-registered",
  PENDING_RELEASE_CROP_PLEDGE: "pending-release-crop-pledge",
  EXPIRING_CROP_PLEDGE: "expiring-crop-pledge-credor",
  RELEASE_CROP_PLEDGE_CREDITOR: "release-crop-pledge-creditor"
};

// src/utils/age-calculation.ts
function calculateAge(unixTimestamp) {
  const timestamp = unixTimestamp > 1e12 ? unixTimestamp : unixTimestamp * 1e3;
  const birthDate = new Date(timestamp);
  const today = /* @__PURE__ */ new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  const dayDiff = today.getDate() - birthDate.getDate();
  if (monthDiff < 0 || monthDiff === 0 && dayDiff < 0) {
    age--;
  }
  return age;
}

// src/utils/format-date.ts
var import_date_fns = require("date-fns");
var DEFAULT_FORMAT = "dd/MM/yyyy";
var formatDate = (date, format) => {
  if (typeof date === "number")
    return (0, import_date_fns.format)(date * 1e3, format != null ? format : DEFAULT_FORMAT);
  return (0, import_date_fns.format)(
    typeof date === "string" ? Number(date) * 1e3 : date,
    format != null ? format : DEFAULT_FORMAT
  );
};
function formatDateToShortFormat(date, lang = "es") {
  const argentinaFormat = "es-AR";
  const usFormat = "en-US";
  const format = lang === "es" ? argentinaFormat : usFormat;
  const spanishFormatter = new Intl.DateTimeFormat(format, {
    dateStyle: "medium"
  });
  return spanishFormatter.format(date);
}

// src/utils/get-unix-timestamp.ts
var getUnixTimestamp = () => Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3);

// src/utils/get-unix-timestamp-in-milliseconds.ts
var getUnixTimestampInMilliseconds = () => Math.floor((/* @__PURE__ */ new Date()).getTime());

// src/utils/http-error-codes.ts
var import_types = require("@bcba/types");
var HTTP_ERROR_CODES = {
  [import_types.ERROR_CODES.VALIDATION_ERROR]: import_types.HttpStatus.BAD_REQUEST,
  [import_types.ERROR_CODES.CANNOT_APPROVE_FACILITY_WITHOUT_AFFIDAVIT]: import_types.HttpStatus.BAD_REQUEST,
  [import_types.ERROR_CODES.CANNOT_SHARE_CERTIFICATES_FROM_ANOTHER_COMPANY]: import_types.HttpStatus.BAD_REQUEST,
  [import_types.ERROR_CODES.CANNOT_SHARE_CERTIFICATES_WITH_YOURSELF]: import_types.HttpStatus.BAD_REQUEST,
  [import_types.ERROR_CODES.MISSING_CREDENTIALS]: import_types.HttpStatus.UNAUTHORIZED,
  [import_types.ERROR_CODES.INVALID_TOKEN]: import_types.HttpStatus.UNAUTHORIZED,
  [import_types.ERROR_CODES.FORBIDDEN_RESOURCE]: import_types.HttpStatus.FORBIDDEN,
  [import_types.ERROR_CODES.RECORD_NOT_FOUND]: import_types.HttpStatus.NOT_FOUND,
  [import_types.ERROR_CODES.SNAPSHOT_ALREADY_APPROVED]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.EMAIL_ALREADY_EXISTS]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.DUPLICATED_ENTITY]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.FISCAL_ID_IN_USE]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.EMPTY_FILE]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.USER_ALREADY_EXISTS]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.COMPANY_ALREADY_EXISTS]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.SNAPSHOT_ALREADY_REJECTED]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.SNAPSHOT_MUST_BE_PENDING_APPROVAL]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.SNAPSHOT_PREVIOUSLY_REJECTED_OR_APPROVED]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.SNAPSHOT_NON_ACTIVE]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.SNAPSHOT_WITH_MISSING_INFORMATION]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.COMPANY_MISSING_A_CERTIFIED_DIGITAL_DOSSIER]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.COMPANY_DOES_NOT_HAVE_AVAILABLE_QUERIES]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.SIGNUP_REQUEST_ALREADY_REJECTED]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.SIGNUP_REQUEST_ALREADY_APPROVED]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.SIGNUP_REQUEST_NOT_IN_A_PENDING_APPROVAL_STATUS]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.SIGNUP_REQUEST_NOT_IN_A_PENDING_CHANGE_REQUEST_STATUS]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.CUIT_MUST_BE_11_DIGITS]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.CUIT_INVALID]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.CUIT_NOT_FOUND_IN_AFIP]: import_types.HttpStatus.CONFLICT,
  [import_types.ERROR_CODES.UPDATES_NOT_TRIGGERED_CHANGES]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.MALFORMED_REQUEST]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.PROCESSING_ERROR]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.NOT_YET_SUPPORTED]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.BRUTE_INCOME_LOCAL_JURISDICTION_MUST_HAVE_SINGLE_JURISDICTION]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.BRUTE_INCOME_MULTILATERAL_AGREEMENT_MUST_HAVE_AT_LEAST_ONE_JURISDICTION]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.BRUTE_INCOME_EXEMPT_MUST_NOT_HAVE_JURISDICTIONS]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CERTIFICATE_REQUEST_ALREADY_IN_PROGRESS]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CROP_PLEDGE_NO_DIGITAL_DOSSIER]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CROP_PLEDGE_NO_COMPANY_CONTACT_INFORMATION]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CROP_PLEDGE_COMPANY_IS_NOT_PRODUCER]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CROP_PLEDGE_NO_PHONE_NUMBER]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CROP_PLEDGE_NO_EMAIL]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CROP_PLEDGE_NO_CP]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CROP_PLEDGE_NO_INCUMBENT]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CROP_PLEDGE_CANT_USE_OWN_COMPANY]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CROP_PLEDGE_COMPANY_NOT_FOUND]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CROP_PLEDGE_CREDITOR_INFORMATION_NOT_FOUND]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CROP_PLEDGE_FARM_INFORMATION_NOT_FOUND]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CROP_PLEDGE_USER_IS_NOT_CREDITOR]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CROP_PLEDGE_NOT_IN_CREDITOR_APPROVAL_STATUS]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CROP_PLEDGE_SECTIONS_NOT_IN_APPROVED_STATUS]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CROP_PLEDGE_INVALID_STAGE]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.CROP_PLEDGE_INVALID_CREDITOR_SELECTION]: import_types.HttpStatus.UNPROCESSABLE_ENTITY,
  [import_types.ERROR_CODES.INTERNAL_SERVER_ERROR]: import_types.HttpStatus.INTERNAL_SERVER_ERROR,
  [import_types.ERROR_CODES.ERROR_SENDING_EMAIL]: import_types.HttpStatus.INTERNAL_SERVER_ERROR,
  [import_types.ERROR_CODES.ERROR_UPLOADING_FILE]: import_types.HttpStatus.INTERNAL_SERVER_ERROR,
  [import_types.ERROR_CODES.ERROR_DELETING_FILE]: import_types.HttpStatus.INTERNAL_SERVER_ERROR,
  [import_types.ERROR_CODES.ERROR_FETCHING_FILE]: import_types.HttpStatus.INTERNAL_SERVER_ERROR,
  [import_types.ERROR_CODES.ERR_NETWORK]: import_types.HttpStatus.INTERNAL_SERVER_ERROR
};

// src/utils/isEmptyDocumentField.ts
var isEmptyDocumentField = (document) => {
  var _a;
  return !document || !(document == null ? void 0 : document.uuid) && !((_a = document == null ? void 0 : document.file) == null ? void 0 : _a.s3TempKey) && !(document == null ? void 0 : document.s3TempKey);
};
var filterEmptyArrayOfDocumentField = (documents) => {
  return documents.filter(({ file, keepOriginal, uuid }) => {
    const hasNewDocumentToUpload = Boolean(file == null ? void 0 : file.s3TempKey);
    const hasPreviouslyUploadedDocument = Boolean(keepOriginal && uuid);
    return hasNewDocumentToUpload || hasPreviouslyUploadedDocument;
  });
};

// src/utils/regex-cuit-cuil.ts
var REGEX_LENGTH_CUIT_CUIL = /^\d{11}$/;
var REGEX_FORMAT_CUIT_CUIL = /\b(20|23|24|27|30|33|34)(\D)?[0-9]{8}(\D)?[0-9]/g;

// src/utils/sanitize-filename.ts
var sanitizeFilename = (filename) => {
  let sanitizedFilename = filename.trim();
  sanitizedFilename = sanitizedFilename.replace(/\s+/g, "_");
  sanitizedFilename = sanitizedFilename.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  sanitizedFilename = sanitizedFilename.replace(/[%+,]/g, "_");
  sanitizedFilename = sanitizedFilename.toLowerCase();
  return sanitizedFilename;
};

// src/utils/time-conversions.ts
var dateToUnixTimestamp = (date) => {
  return (date != null ? date : /* @__PURE__ */ new Date()).getTime() / 1e3;
};
var unixTimestampToDate = (unixTimestamp) => {
  return new Date(unixTimestamp * 1e3);
};

// src/utils/validate-email.ts
var validateEmail = (email) => {
  return String(email).toLowerCase().match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

// src/web-socket-events/index.ts
var WEB_SOCKET_EVENTS = {
  PENDING_CERTIFICATE_REQUESTS_COUNT: "pendingCertificateRequestsCount",
  PENDING_CERTIFICATE_SHARE_REQUESTS_COUNT: "pendingCertificateShareRequestsCount"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  EMAIL_TEMPLATE_IDS,
  HTTP_ERROR_CODES,
  REGEX_FORMAT_CUIT_CUIL,
  REGEX_LENGTH_CUIT_CUIL,
  WEB_SOCKET_EVENTS,
  calculateAge,
  dateToUnixTimestamp,
  filterEmptyArrayOfDocumentField,
  formatDate,
  formatDateToShortFormat,
  getUnixTimestamp,
  getUnixTimestampInMilliseconds,
  isEmptyDocumentField,
  sanitizeFilename,
  unixTimestampToDate,
  validateEmail
});
